import React, { useState } from 'react';
import { CheckCircle2, ChevronDown, ChevronUp } from 'lucide-react';
const tomos = [{
  icon: '🔵',
  title: 'TOMO 1 — DIAGNÓSTICO PROFESIONAL™',
  subtitle: 'Dejá de actuar sin evaluar correctamente primero.',
  accent: 'border-l-brand-primary',
  items: ['Detectar mejor cada situación antes de actuar', 'Tomar decisiones con más criterio', 'Reducir errores evitables', 'Estructurar mejor consultas iniciales', 'Sentir más seguridad profesional desde el primer contacto']
}, {
  icon: '🟢',
  title: 'TOMO 2 — PROTOCOLOS DE SERVICIO™',
  subtitle: 'Dejá de resolver cada servicio como si fuera un caso nuevo.',
  accent: 'border-l-brand-primary',
  items: ['Trabajar con procesos más claros', 'Reducir improvisación operativa', 'Repetir mejores prácticas', 'Ordenar mejor tu flujo diario', 'Sentir más consistencia en cómo trabajás']
}, {
  icon: '🟣',
  title: 'TOMO 3 — CLIENTAS Y CONSULTAS™',
  subtitle: 'Mejorá cómo te comunicás y cómo te perciben.',
  accent: 'border-l-brand-primary',
  items: ['Responder con más seguridad', 'Manejar mejor expectativas', 'Mejorar percepción profesional', 'Reducir fricción con clientas', 'Sentir más claridad en tus conversaciones']
}, {
  icon: '🟠',
  title: 'TOMO 4 — ORGANIZACIÓN DEL SALÓN™',
  subtitle: 'Bajá caos operativo y ganá más control.',
  accent: 'border-l-brand-primary',
  items: ['Organizar mejor tu operación', 'Reducir desorden diario', 'Mejorar flujo interno', 'Trabajar con más control', 'Ahorrar energía mental']
}, {
  icon: '🔴',
  title: 'TOMO 5 — COBRO Y PRESUPUESTOS™',
  subtitle: 'Dejá de sentir incomodidad al momento de cobrar.',
  accent: 'border-l-brand-primary',
  items: ['Presupuestar con más claridad', 'Comunicar precios con más seguridad', 'Mejorar percepción de valor', 'Reducir incomodidad comercial', 'Tomar decisiones más firmes']
}, {
  icon: '🟡',
  title: 'TOMO 6 — EXPERIENCIA PREMIUM Y CRECIMIENTO™',
  subtitle: 'Elevá cómo te perciben y trabajá como una profesional consolidada.',
  accent: 'border-l-brand-primary',
  items: ['Mejorar experiencia clienta', 'Elevar percepción profesional', 'Fortalecer fidelización', 'Construir una experiencia más premium', 'Crecer con más estructura']
}];
const features = ['herramientas prácticas', 'aplicación inmediata', 'enfoque real de peluquería', 'explicaciones claras', 'recursos utilizables', 'estructura profesional aplicable'];
export function TomosSection() {
  const [expandedIdx, setExpandedIdx] = useState<number | null>(null);
  return <section className="bg-white py-8 px-5 relative overflow-hidden" data-id="element-331">
      <div className="max-w-xl mx-auto relative z-10" data-id="element-332">
        <h2 className="md:text-4xl font-black text-center text-slate-900 mb-4 text-[20px]" data-id="element-333">
          📚 LO QUE RECIBÍS HOY
        </h2>
        <p className="text-center text-sm font-bold mb-10 uppercase tracking-widest text-brand-primary" data-id="element-334">
          6 TOMOS DISEÑADOS PARA AYUDARTE A DEJAR DE IMPROVISAR
        </p>

        <div className="space-y-4 mb-10" data-id="element-335">
          {tomos.map((tomo, idx) => {
          const isOpen = expandedIdx === idx;
          return <div key={idx} className={`bg-slate-50 border border-slate-100 border-l-4 ${tomo.accent} rounded-2xl overflow-hidden transition-all hover:bg-white hover:shadow-md`} data-id="element-336">
                <button onClick={() => setExpandedIdx(isOpen ? null : idx)} className="w-full p-6 flex items-start gap-4 text-left" data-id="element-337">
                  <span className="text-3xl flex-shrink-0" data-id="element-338">{tomo.icon}</span>
                  <div className="flex-grow min-w-0" data-id="element-339">
                    <h3 className="text-base font-black text-slate-900 mb-1" data-id="element-340">
                      {tomo.title}
                    </h3>
                    <p className="text-sm text-slate-500 font-medium" data-id="element-341">
                      {tomo.subtitle}
                    </p>
                  </div>
                  {isOpen ? <ChevronUp size={20} className="text-brand-primary flex-shrink-0 mt-1" data-id="element-342" /> : <ChevronDown size={20} className="text-brand-primary/30 flex-shrink-0 mt-1" data-id="element-343" />}
                </button>
                {isOpen && <div className="px-6 pb-6 pl-16" data-id="element-344">
                    <div className="space-y-3" data-id="element-345">
                      {tomo.items.map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-346">
                          <CheckCircle2 className="text-brand-primary" size={16} data-id="element-347" />
                          <span className="text-sm text-slate-600 font-medium" data-id="element-348">
                            {item}
                          </span>
                        </div>)}
                    </div>
                  </div>}
              </div>;
        })}
        </div>

        <div className="bg-slate-50 border border-slate-100 rounded-2xl p-8" data-id="element-349">
          <h3 className="text-lg font-black text-center text-brand-primary mb-6" data-id="element-350">
            ✨ Cada tomo incluye:
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-351">
            {features.map((feature, idx) => <div key={idx} className="flex items-center gap-3" data-id="element-352">
                <CheckCircle2 className="text-brand-primary flex-shrink-0" size={20} data-id="element-353" />
                <span className="text-sm text-slate-700 font-bold uppercase tracking-tight" data-id="element-354">
                  {feature}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}